<template>
    <div>
        <el-tooltip>
            <div slot="content">{{ content }}</div>
            <div
                ref="textRef"
                class="overflow-text truncate"
                :style="{ textOverflow: overfloType }"
            >
                {{ content }}
            </div>
        </el-tooltip>
    </div>
</template>
<script>
export default {
    props:{
        content:{
            type:String,
        },
        overfloType: {
            type: String,  //ellipsis' | 'unset' | 'clip
            default: 'ellipsis'
        }
    },
    data(){
        return {
            disabled:true,
        }
    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>

</style>